import { Reveal, SectionHeading } from "./Primitives";
import { CLIENT_POLICY } from "@/data/content";
import { ShieldCheck } from "lucide-react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export const ClientPolicy = () => (
  <section id="policy" className="bg-[#050505] py-20 md:py-32">
    <div className="mx-auto max-w-[1000px] px-5 md:px-10">
      <Reveal>
        <SectionHeading
          overline="Client Policy"
          title={<>Clear terms, <span className="gold-gradient italic">no surprises</span></>}
          subtitle="A few simple policies that keep every Perfect Touch service smooth and professional. Tap any policy to read the details."
        />
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 w-full border-t border-white/10">
          {CLIENT_POLICY.map((p, i) => (
            <AccordionItem
              key={p.title}
              value={`policy-${i}`}
              data-testid={`policy-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="text-left hover:no-underline py-5 group">
                <span className="flex items-center gap-3">
                  <ShieldCheck size={20} className="text-gold shrink-0" strokeWidth={1.5} />
                  <span className="font-display text-lg md:text-xl text-white group-hover:text-gold transition-colors">
                    {p.title}
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-zinc-400 leading-relaxed pb-6 pl-8">
                {p.text}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
